import axios from 'axios'

// Currently, this exists so it can be easily mocked in tests
// but it can also be used in the future to add any common config.
const HTTP = axios.create()

export default HTTP
